/**
 * @param { String } holderSelector
 * @param { String } contentSelector
 * @param { Boolean } doInitialScroll
 */
export const initializeScrollIndicator = (holderSelector, contentSelector, doInitialScroll = false) => {
    const holders = document.querySelectorAll(holderSelector)

    for (const holder of holders) {
        const content = holder.querySelector(contentSelector)

        // if already initialized, skip initializing this one
        if (
            holder.classList.contains('is-initialized')
            || !content
        ) {
            continue
        }

        initialize(holder, content, doInitialScroll)
    }
}

/**
 *
 * @param { HTMLElement } holder
 * @param { HTMLElement } content
 * @param { Boolean } doInitialScroll
 */
function initialize(holder, content, doInitialScroll = false) {
    content.addEventListener('customUpdateScroll', () => update(holder, content))
    content.addEventListener('scroll', () => update(holder, content))
    rEvent.on('Window.resized', () => update(holder, content))
    update(holder, content)

    if (doInitialScroll) {
        // scroll to very right if scrollable
        if (content.scrollWidth > holder.offsetWidth) {
            content.scroll({
                left: content.scrollWidth - content.lastElementChild.offsetWidth + 10,
                behavior: 'smooth'
            })
        }
    }

    holder.classList.add('is-initialized')
}

/**
 *
 * @param { HTMLElement } holder
 * @param { HTMLElement } content
 */
function update(holder, content) {
    let isScrollableUp = false
    let isScrollableDown = false
    let isScrollableLeft = false
    let isScrollableRight = false

    if (content.scrollHeight > holder.offsetHeight) {
        isScrollableUp = Math.floor(content.scrollTop) > 0
        isScrollableDown = Math.ceil(content.scrollTop) < content.scrollHeight - content.offsetHeight
    }

    if (content.scrollWidth > holder.offsetWidth) {
        isScrollableLeft = Math.floor(content.scrollLeft) > 0
        isScrollableRight = Math.ceil(content.scrollLeft) < content.scrollWidth - content.offsetWidth
    }

    holder.classList.toggle('is-scrollable-left', isScrollableLeft);
    holder.classList.toggle('is-scrollable-right', isScrollableRight);
    holder.classList.toggle('is-scrollable-up', isScrollableUp);
    holder.classList.toggle('is-scrollable-down', isScrollableDown);
}
